import { render, staticRenderFns } from "./Inspiration.vue?vue&type=template&id=df1d3516&scoped=true"
import script from "./Inspiration.vue?vue&type=script&lang=js"
export * from "./Inspiration.vue?vue&type=script&lang=js"
import style0 from "./_inspiration.css?vue&type=style&index=0&id=df1d3516&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df1d3516",
  null
  
)

export default component.exports